import lucene from "lucene";

const solrFields = [
    "id",
    "title",
    "title_txt_de",
    "work_txt_id",
    "edition_txt_de",
    "transcript_txt_de",
    "comments_txt_de",
    "authority_txt_de",
    "proverb_txt_de",
    "title_txt_en",
    "translation_txt_en",
    "metadata_txt_de",
    "app_txt_de",
    "keyword_ss",
    "motif_txts_en",
    "person_ss",
    "place_ss",
    "verse_or_prose",
];

const clientFields = [
    "id",
    "titel_exakt",
    "titel",
    "werk_id",
    "editionstext",
    "transkriptionstext",
    "kommentartext",
    "authority",
    "proverb",
    "titel_en",
    "uebersetzung",
    "metadata",
    "apparatus",
    "schlagwort",
    "motiv",
    "person",
    "ort",
    "verse",
];

function transformNode(node) {
    const transformed = { ...node };
    const { left, right, field } = transformed;
    if (left) {
        transformed.left = transformNode(left);
    }
    if (right) {
        transformed.right = transformNode(right);
    }
    if (field) {
        // Search both DE/EN titles, by creating an OR clause: (title_txt_de:value OR title_txt_en:value)
        if (field === "titel") {
            return {
                operator: "OR",
                left: transformNode({ ...node, field: "title_txt_de" }),
                right: transformNode({ ...node, field: "title_txt_en" }),
            };
        }
        transformed.field = translateClientFieldToSolrField(field);
    }

    return transformed;
}

export function transformQuery(query) {
    try {
        const parsedQuery = lucene.parse(query);
        const transformedQuery = transformNode(parsedQuery);
        return lucene.toString(transformedQuery);
    } catch (e) {
        console.error(e);
        return query;
    }
}

function translateClientFieldToSolrField(field) {
    if (clientFields.some((f) => f === field)) {
        return solrFields[clientFields.indexOf(field)];
    } else {
        return field;
    }
}

export default { clientFields, solrFields, transformQuery };
